import { ApiResponse, axiosInstance } from '@/lib/axios';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/react-query';
import { TFetchParams } from '@/types/fetch.type';
import { TUrlSpaceMember } from '../types/ticketing-user.type';

export type TGetUrlSpaceMemberResponse = ApiResponse<TUrlSpaceMember>;
export type TGetUrlSpaceMemberParams = TFetchParams & {
  spaceId: string;
};

export const getUrlSpaceMember = async (params: TGetUrlSpaceMemberParams): Promise<TGetUrlSpaceMemberResponse> => {
  const url = `/space-member/invitation-link/${params.spaceId}`;
  return axiosInstance.get(url);
};

export const GET_URL_SPACE_MEMBER_QUERY_KEY = 'get-url-space-member';

export const getUrlSpaceMemberQueryOptions = (params: TGetUrlSpaceMemberParams) => {
  return queryOptions({
    queryKey: [GET_URL_SPACE_MEMBER_QUERY_KEY, { spaceId: params.spaceId }],
    queryFn: () => getUrlSpaceMember(params),
  });
};

type UseUrlSpaceMemberQueryOptions = {
  params: TGetUrlSpaceMemberParams;
  queryConfig?: QueryConfig<typeof getUrlSpaceMemberQueryOptions>;
};

export const useUrlSpaceMemberQuery = ({ params, queryConfig }: UseUrlSpaceMemberQueryOptions) => {
  return useQuery({
    ...getUrlSpaceMemberQueryOptions(params),
    ...queryConfig,
  });
};
